import { Storage } from "./storage";
import { COMPANY_TYPE } from 'constant';

export const text_companyNm = () => {
  const loginInfo = Storage.session.get('loginInfo');
  if(loginInfo?.cGbn === COMPANY_TYPE.BENZ) {
    return '딜러사';
  } else {
    return '사무소';
  }
};

export const text_columes = () => {
  const loginInfo = Storage.session.get('loginInfo');
  if(loginInfo?.cGbn === COMPANY_TYPE.BENZ) {
    return '지사';
  } else {
    return '사무소';
  }
};